import React from 'react';
import { useAppState, MarkupRender, getUploadedImagePath } from '@nutastic/nutastic-react-app';
import PageHeader from '../PageHeader';
import getBackgroundColor from '../../utils/getBackgroundColor';

const CustomPage = () => {
    const {
        page: {
            image_1: mainImage,
            num_4: headerBackgroundColor,
            title,
            content,
            field_10: subtext,
            num_5: headerType,
            field_1_filtered: s1Content,
            num_1: s1Color,
            field_2_filtered: s2Content,
            num_2: s2Color,
            field_3_filtered: s3Content,
            num_3: s3Color
        }
    } = useAppState();

    const renderContentSection = (sectionContent, colorId) => {
        const bgColorClass = getBackgroundColor(colorId);
        return sectionContent ? <section className={`page-section ${bgColorClass} page-section--padded`}>
            <div className="container text-left">
                <div className="paragraph"><MarkupRender content={sectionContent} /></div>
            </div>
        </section> : null;
    };

    return <React.Fragment>
        <PageHeader
            backgroundColorId={headerBackgroundColor}
            image={getUploadedImagePath(mainImage)}
            type={headerType}
            title={title}
            subtext={subtext}
        />
        { renderContentSection(content) }
        { renderContentSection(s1Content, s1Color) }
        { renderContentSection(s2Content, s2Color) }
        { renderContentSection(s3Content) }
    </React.Fragment>;
};

export default CustomPage;
